import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullUserV4 from "@irati/identity/services/fragments/fullUserV4"
import fullBusiness from "@irati/identity/services/fragments/fullBusiness"

const query = gql`
  query LoginGhostTokenForBusiness {
    loginGhost {
      user {
        ...fullUser
      }
      business {
        ...fullBusiness
      }
    }
  }
  ${fullUserV4}
  ${fullBusiness}
`

export const loginGhostKey = getQueryNames(query)[0]

export default query
